module.exports = __webpack_public_path__ + "media/images/bg-leaderboard-card-header@2x-5aaadb3cb44eb947d0d99b69772a6644.webp";